// import {
//   Box,
//   Paper,
//   Typography,
//   Grid,
//   LinearProgress,
//   Button,
//   Tooltip,
//   tooltipClasses,
//   styled,
//   TableCell,
//   TableHead,
//   TableBody,
//   TableRow,
//   Table,
//   AccordionSummary,
//   AccordionDetails,
//   Accordion,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router";
// import { Actions } from "../../redux/Actions/Actions";
// import { useDispatch, useSelector } from "react-redux";
// import { getAllBetData } from "../../Utility/API";
// import { sportEndPoint } from "../../constant/Environment";
// import Loader from "../Loader";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { isMobile } from "react-device-detect";

// const Poolcard = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [poolData, setPoolData] = useState([]);
//   const [isLoading, setIsLoadinig] = useState(false);
//   const [storeId, setStoreId] = useState("");
//   const [expanded, setExpanded] = useState(false);
//     const state = useSelector((state) => state);

//   const LightTooltip = styled(({ className, ...props }) => (
//     <Tooltip {...props} arrow classes={{ popper: className }} />
//   ))(({ theme }) => ({
//     [`& .${tooltipClasses.tooltip}`]: {
//       backgroundColor: "#fff",
//       color: "#1e1e1e", // or any color like '#007BFF'
//       boxShadow: theme.shadows[3],
//       border: "1px solid #ccc",
//       fontSize: 12,
//       padding: 8,
//     },
//   }));

//   const fetchPools = async (eventId) => {
//     setIsLoadinig(true);
//     try {
//       const url = `${sportEndPoint.apiBaseUrl}${sportEndPoint.api.POOL_DATA}/${eventId}`;
//       const poolValues = await getAllBetData(url);
//       setIsLoadinig(false);
//       setPoolData(poolValues ?? []);
//     } catch (error) {
//       console.error("Failed to fetch pool data:", error);
//     } finally {
//       setIsLoadinig(false);
//     }
//   };

//   useEffect(() => {
//     let params = new URLSearchParams(window.location.search);
//     let eventId = params.get("eventId") || "";
//     setStoreId(eventId);
//     if (eventId) {
//       fetchPools(eventId);
//     }
//   }, []);

//   const handlePools = (item) => {
//     // debugger
//      if(item?.id != state?.betslip?.poolId){
//           dispatch({
//           type: Actions.REMOVE_ALL_BETSLIP,
//         });
//       }
//     navigate(`/players?poolId=${storeId}`);
//     dispatch({
//       type: Actions.POOL_ID,
//       data: item.id,
//     });
//     dispatch({
//       type: Actions.POOL_DATA,
//       data: item,
//     });
//   };

//  const getPayoutTable = (data) => {

//   const rows = [];
//   const step = isMobile ? 1 : 2;

//   for (let i = 0; i < data.length; i += step) {
//     rows.push(data.slice(i, i + step));
//   }

//   return (
//     <Box sx={{ overflowX: 'auto', width: '100%' }}>
//       <Table className="table-bordered" size="small">
//         <TableHead>
//           <TableRow>
//             <TableCell>Position</TableCell>
//             <TableCell>Prize</TableCell>
//             {!isMobile && (
//               <>
//                 <TableCell>Position</TableCell>
//                 <TableCell>Prize</TableCell>
//               </>
//             )}
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {rows.map((pair, index) => (
//             <TableRow key={index}>
//               <TableCell>{pair[0]?.position}</TableCell>
//               <TableCell>${pair[0]?.payout_amount}</TableCell>
//               {!isMobile && (
//                 <>
//                   <TableCell>{pair[1]?.position ?? ""}</TableCell>
//                   <TableCell>{pair[1] ? `$${pair[1].payout_amount}` : ""}</TableCell>
//                 </>
//               )}
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </Box>
//   );
// };

//   return (
//     <>
//       {isLoading && <Loader visible={isLoading} />}

//       <Grid sx={{ width: "100%", marginBottom: "15px" }}>
//         <Paper
//           elevation={3}
//           sx={{
//             border: "1px solid white",
//             borderRadius: "5px",
//             padding: "10px",
//             background: "whitesmoke",
//           }}
//         >
//           <Box
//             sx={{
//               maxHeight: "720px",
//               overflowY: "auto",
//               // Hide scrollbar in WebKit browsers
//               "&::-webkit-scrollbar": {
//                 width: "6px",
//               },
//               "&::-webkit-scrollbar-track": {
//                 background: "transparent",
//               },
//               "&::-webkit-scrollbar-thumb": {
//                 backgroundColor: "transparent",
//               },
//               // Optional: Firefox
//               scrollbarWidth: "none", // for Firefox
//               "&": {
//                 msOverflowStyle: "none", // IE and Edge
//                 scrollbarWidth: "none", // Firefox again
//               },
//             }}
//           >
//             {poolData.length > 0 &&
//               poolData?.map((item, index) => {
//                 const currentEntries = item?.poolSize - item?.freeEntries;
//                 const progressPercent =
//                   (currentEntries / item?.poolSize) * 100;
//                 return (
//                   <Paper
//                     elevation={3}
//                     sx={{
//                       p: 2,
//                       borderRadius: 2,
//                       bgcolor: "#fff",
//                       marginTop: "10px",
//                     }}
//                   >
//                     <Box
//                       sx={{ display: "flex", justifyContent: "space-between" }}
//                     >
//                       <Typography
//                         variant="subtitle1"
//                         sx={{
//                           color: "green",
//                           fontWeight: 600,
//                           fontSize: { xs: "14px", md: "17px" },
//                         }}
//                       >
//                         {item?.title} {" "}
//                       </Typography>

//                       <Typography
//                         variant="subtitle1"
//                         sx={{
//                           color: "green",
//                           fontWeight: 600,
//                           fontSize: { xs: "14px", md: "17px" },
//                         }}
//                       >
//                         Max Entries: {item?.poolSize}
//                       </Typography>
//                     </Box>
//                     <Box mt={1}>
//                       <LinearProgress
//                         variant="determinate"
//                         value={progressPercent}
//                         sx={{
//                           height: 8,
//                           borderRadius: 5,
//                           bgcolor: "#eee",
//                           "& .MuiLinearProgress-bar": {
//                             backgroundColor: "#c62828",
//                           },
//                         }}
//                       />
//                     </Box>

//                     <Box display="flex" justifyContent="space-evenly" mt={1}>
//                       <Typography variant="body2">
//                         {currentEntries} Entries
//                       </Typography>
//                       <Typography variant="body2">
//                         {item?.freeEntries} spots available
//                       </Typography>
//                     </Box>

//                     <Box mt={2}>
//                       <Button
//                         fullWidth
//                         variant="contained"
//                         color="success"
//                         disabled={
//                           !(item?.enable)
//                         }
//                         onClick={() => {
//                           handlePools(item);
//                         }}
//                       >
//                         ${item?.price} Join
//                       </Button>
//                     </Box>

//                     <Accordion
//                       elevation={0}
//                       // expanded={true}
//                       sx={{
//                         background: "transparent",
//                         boxShadow: "none",
//                         mt: 1,
//                         "&:before": {
//                           display: "none",
//                         },
//                       }}
//                       expanded={expanded == index} // assume each item has a unique `id`
//                       onChange={() =>
//                         setExpanded(expanded === index ? null : index)
//                       }
//                     >
//                       <AccordionSummary
//                         expandIcon={false} // disable default icon position
//                         sx={{ justifyContent: "center" }} // center the whole content
//                       >
//                         <Box
//                           display="flex"
//                           justifyContent="center"
//                           alignItems="center"
//                           gap={1}
//                           width="100%"
//                           sx={{ height: "24px" }}
//                         >
//                           <Typography
//                             variant="body1"
//                             fontWeight={500}
//                             sx={{ color: "green !important" }}
//                           >
//                             Contest Pool Info
//                           </Typography>
//                           <ExpandMoreIcon
//                             sx={{
//                               transform:
//                                 expanded == index
//                                   ? "rotate(180deg)"
//                                   : "rotate(0deg)",
//                               // transition: "0.3s",
//                               color: "green !important",
//                             }}
//                           />
//                         </Box>
//                       </AccordionSummary>
//                       <AccordionDetails sx={{ p: 0 }}>
//                         <Box sx={{ p: 0, m: 0 }}>
//                           <Typography variant="body1" gutterBottom>
//                             Pool Breakdown
//                           </Typography>
//                           {getPayoutTable(item?.leatherboard)}
//                         </Box>
//                         <Grid
//                           container
//                           spacing={2}
//                           sx={{ width: "100%", marginTop: "15px" }}
//                         >
//                           <Grid item sx={{ width: "40%" }}>
//                             <Typography
//                               variant="subtitle2"
//                               color="text.secondary"
//                               sx={{ textAlign: "center", color: "green" }}
//                             >
//                               Sport
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               sx={{ textAlign: "center", color: "green" }}
//                             >
//                               {item?.sportName}
//                             </Typography>
//                           </Grid>

//                           <Grid item sx={{ width: "40%" }}>
//                             <Typography
//                               variant="subtitle2"
//                               sx={{ textAlign: "center", color: "green" }}
//                             >
//                               Max Entries per user
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               sx={{ textAlign: "center", color: "green" }}
//                             >
//                               {item?.entryPerPlayer}
//                             </Typography>
//                           </Grid>

//                           <Grid item sx={{ width: "40%" }}>
//                             <Typography
//                               variant="subtitle2"
//                               color="text.secondary"
//                               sx={{ textAlign: "center", color: "green" }}
//                             >
//                               Team Size
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               sx={{ textAlign: "center", color: "green" }}
//                             >
//                               {item?.teamSize}
//                             </Typography>
//                           </Grid>

//                           <Grid item sx={{ width: "40%" }}>
//                             <Typography
//                               variant="subtitle2"
//                               color="text.secondary"
//                               sx={{ textAlign: "center", color: "green" }}
//                             >
//                               Remaining spots
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               sx={{ textAlign: "center", color: "green" }}
//                             >
//                               {item?.freeEntries}
//                             </Typography>
//                           </Grid>
//                         </Grid>
//                       </AccordionDetails>
//                     </Accordion>

//                     {/* <Box
//                     display="flex"
//                     justifyContent="space-between"
//                     alignItems="center"
//                     mt={2}
//                     flexWrap="wrap"
//                   >
//                     <LightTooltip title={getPayoutTable(item?.leatherboard)}>
//                       <Typography variant="body2" sx={{ cursor: "pointer" }}>
//                         🏆 ${item?.max_win.toLocaleString()}
//                       </Typography>
//                     </LightTooltip>
//                     <LightTooltip
//                       title={`Maximum ${item?.max_bet} entries allowed per user`}
//                     >
//                       <Typography variant="body2">
//                         🎫 MAX {item?.max_bet}
//                       </Typography>
//                     </LightTooltip>
//                     <Typography variant="body2">👥 375</Typography>
//         <Typography variant="body2">Flexible</Typography>
//                   </Box> */}
//                   </Paper>
//                 );
//               })}
//           </Box>
//         </Paper>
//       </Grid>
//     </>
//   );
// };

// export default Poolcard;

import CloseIcon from "@mui/icons-material/Close";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Skeleton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getAllBetData } from "../../Utility/API";
import { sportEndPoint } from "../../constant/Environment";
import { Actions } from "../../redux/Actions/Actions";
import { FantasyScoringTable } from "./FantasyScoringTable";

const Poolcard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [poolData, setPoolData] = useState([]);
  const [isLoading, setIsLoadinig] = useState(false);
  const [storeId, setStoreId] = useState("");
  const state = useSelector((state) => state);

  const [payoutDialog, setPayoutDialog] = useState({ open: false, item: null });

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      color: "#1e1e1e",
      boxShadow: theme.shadows[3],
      border: "1px solid #ccc",
      fontSize: 12,
      padding: 8,
    },
  }));

  const fetchPools = async (eventId) => {
    setIsLoadinig(true);
    try {
      const url = `${sportEndPoint.apiBaseUrl}${sportEndPoint.api.POOL_DATA}/${eventId}`;
      const poolValues = await getAllBetData(url);
      setPoolData(poolValues ?? []);
    } catch (error) {
      console.error("Failed to fetch pool data:", error);
    } finally {
      setIsLoadinig(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const eventId = params.get("eventId") || "";
    setStoreId(eventId);
    if (eventId) fetchPools(eventId);
  }, []);

  const handlePools = (item) => {
    if (item?.id !== state?.betslip?.poolId) {
      dispatch({ type: Actions.REMOVE_ALL_BETSLIP });
    }
    navigate(`/players?poolId=${storeId}`);
    dispatch({ type: Actions.POOL_ID, data: item.id });
    dispatch({ type: Actions.POOL_DATA, data: item });
  };

  // format money to 2 decimals, handles number or numeric string
  const formatMoney = (v) => {
    if (v === null || v === undefined || v === "") return "";
    const n = Number(v);
    if (Number.isNaN(n)) return "";
    return `$${n.toFixed(2)}`;
  };

  const openPayouts = (item) => setPayoutDialog({ open: true, item });
  const closePayouts = () => setPayoutDialog({ open: false, item: null });

  const getPayoutTable = (data = []) => {
    const rows = Array.isArray(data) ? data : [];
    // Build aligned amounts so that the `$` stacks vertically across rows
    const rawAmounts = rows.map((r) =>
      r?.payout_amount !== undefined ? formatMoney(r.payout_amount) : ""
    );
    // find the longest numeric part (excluding the $)
    const maxDigits = rawAmounts.reduce((m, s) => {
      const len = s ? s.replace("$", "").length : 0;
      return Math.max(m, len);
    }, 0);
    const FIGURE_SPACE = "\u2007"; // width of a numeral in most fonts

    const toAligned = (s) => {
      if (!s) return "";
      const num = s.replace("$", "");
      const pad = Math.max(0, maxDigits - num.length);
      // use figure spaces so alignment works even in proportional fonts
      return `$${FIGURE_SPACE.repeat(pad)}${num}`;
    };

    return (
      <TableContainer
        sx={{
          maxHeight: 360,
          border: "1px solid rgba(0,0,0,0.08)",
          borderRadius: 1.5,
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell width={110}>Position</TableCell>
              <TableCell width={140}>Percentage Distribution</TableCell>
              <TableCell align="right" width={140}>
                Prize
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow
                key={idx}
                hover
                sx={{ "&:nth-of-type(odd)": { bgcolor: "rgba(0,0,0,0.02)" } }}
              >
                <TableCell>{row?.position}</TableCell>
                <TableCell sx={{textAlign:"center"}}>{row?.finalPayout}{"%"}</TableCell>
                <TableCell align="right">
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 700,
                      fontFamily:
                        "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, monospace",
                      fontVariantNumeric: "tabular-nums",
                      whiteSpace: "pre",
                    }}
                  >
                    {row?.payout_amount !== undefined
                      ? toAligned(formatMoney(row.payout_amount))
                      : ""}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const contentSkeleton = useMemo(
    () => (
      <Stack spacing={2} sx={{ p: 2 }}>
        {[...Array(3)].map((_, i) => (
          <Card key={i} sx={{ borderRadius: 2 }}>
            <Skeleton variant="rectangular" height={64} />
            <CardContent>
              <Skeleton width="60%" />
              <Skeleton width="40%" />
              <Skeleton variant="rectangular" height={8} sx={{ mt: 2 }} />
            </CardContent>
            <CardActions>
              <Skeleton variant="rectangular" height={36} width={120} />
            </CardActions>
          </Card>
        ))}
      </Stack>
    ),
    []
  );

  return (
    <>
      {/* {isLoading && <Loader visible={isLoading} />} */}

      <Grid sx={{ width: "100%", mb: 2 }}>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#f7f7f9",
            border: "1px solid rgba(0,0,0,0.06)",
          }}
        >
          <Box
            sx={{
              maxHeight: 720,
              overflowY: "auto",
              "&::-webkit-scrollbar": { width: 6 },
              "&::-webkit-scrollbar-thumb": { backgroundColor: "transparent" },
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {poolData?.length === 0 && !isLoading && (
              <Box sx={{ textAlign: "center", py: 8 }}>
                <EmojiEventsOutlinedIcon />
                <Typography variant="h6" sx={{ mt: 1 }}>
                  No contests yet
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Check back soon for new pools.
                </Typography>
              </Box>
            )}

            {isLoading && contentSkeleton}

            {poolData?.map((item, index) => {
              const currentEntries =
                (item?.poolSize ?? 0) - (item?.freeEntries ?? 0);
              const progressPercent = item?.poolSize
                ? Math.min(
                    100,
                    Math.max(0, (currentEntries / item.poolSize) * 100)
                  )
                : 0;

              const isOpen = !!item?.enable;

              return (
                <Card
                  key={item?.id || index}
                  elevation={0}
                  sx={{
                    mb: 2,
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid rgba(0,0,0,0.08)",
                    "&:hover": { boxShadow: (t) => t.shadows[3] },
                  }}
                >
                  {/* Header */}
                  <Box
                    sx={{
                      px: 2,
                      py: 1.5,
                      background:
                        "linear-gradient(90deg, #0D3862 0%, #0a4a7a 60%, #0d3862 100%)",
                      // background:
                      //   "linear-gradient(90deg, #0f9d58 0%, #34a853 60%, #81c995 100%)",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      sx={{ minWidth: 0 }}
                    >
                      <EmojiEventsOutlinedIcon fontSize="small" />
                      <Typography
                        variant="subtitle1"
                        noWrap
                        sx={{ fontWeight: 700, letterSpacing: 0.2 }}
                      >
                        {/* {String(item?.title || 'Contest').toUpperCase()} */}
                        {item?.title?.toUpperCase() || "Contest"}
                      </Typography>
                      <Chip
                        size="small"
                        label={item?.sportName || "Sport"}
                        sx={{
                          color: "white",
                          borderColor: "rgba(255,255,255,0.6)",
                          border: "1px solid",
                          bgcolor: "transparent",
                        }}
                      />
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Chip
                        size="small"
                        variant="outlined"
                        sx={{
                          color: "white",
                          borderColor: "rgba(255,255,255,0.6)",
                        }}
                        label={`Max ${item?.poolSize || 0}`}
                      />
                      {isOpen ? (
                        <LockOpenOutlinedIcon fontSize="small" />
                      ) : (
                        <LockOutlinedIcon fontSize="small" />
                      )}
                    </Stack>
                  </Box>

                  <CardContent sx={{ pt: 2 }}>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      alignItems={{ xs: "flex-start", sm: "center" }}
                      justifyContent="space-between"
                      spacing={2}
                    >
                      <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                        flexWrap="wrap"
                      >
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Groups2OutlinedIcon fontSize="small" />
                          <Typography variant="body2">
                            {currentEntries} entered
                          </Typography>
                        </Stack>
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ display: { xs: "none", sm: "block" } }}
                        />
                        <Typography variant="body2">
                          {item?.freeEntries} spots left
                        </Typography>
                      </Stack>

                      <Stack direction="row" spacing={1} alignItems="center">
                        <LightTooltip title={`Team Size : ${item?.teamSize}`}>
                          <Chip
                            label={`Team Size ${item?.teamSize}`}
                            size="small"
                          />
                        </LightTooltip>
                        <LightTooltip title={`Entry price: $${item?.price}`}>
                          <Chip label={`$${item?.price} entry`} size="small" />
                        </LightTooltip>
                        <LightTooltip
                          title={`Max entries per user: ${item?.entryPerPlayer}`}
                        >
                          <Chip
                            label={`Max ${item?.entryPerPlayer}/user`}
                            size="small"
                            variant="outlined"
                          />
                        </LightTooltip>
                      </Stack>
                    </Stack>

                    <Box mt={2}>
                      <LinearProgress
                        variant="determinate"
                        value={progressPercent}
                        sx={{
                          height: 10,
                          borderRadius: 6,
                          bgcolor: "#e9ecef",
                          "& .MuiLinearProgress-bar": {
                            background:
                              "linear-gradient(90deg, #c62828 0%, #ef5350 100%)",
                            borderRadius: 6,
                          },
                        }}
                      />
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        sx={{ mt: 0.5 }}
                      >
                        <Typography variant="caption">
                          {Math.round(progressPercent)}% filled
                        </Typography>
                        <Typography variant="caption">
                          {item?.poolSize} total
                        </Typography>
                      </Stack>
                    </Box>
                  </CardContent>

                  <CardActions
                    sx={{
                      px: 2,
                      pb: 2,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button
                      variant="text"
                      size="small"
                      onClick={() => openPayouts(item)}
                      startIcon={<InfoOutlinedIcon />}
                      sx={{ textTransform: "none", px: 0 }}
                    >
                      Payouts & Rules
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      disabled={!isOpen}
                      onClick={() => handlePools(item)}
                      sx={{ minWidth: 140, bgcolor: isOpen ? "#179624" : "" }}
                      fullWidth={false}
                    >
                      {isOpen ? `$${item?.price}  Join now` : "Entries closed"}
                    </Button>
                  </CardActions>

                  <Divider />
                </Card>
              );
            })}
          </Box>
        </Paper>
      </Grid>
      {/* Dialog for Payouts & Rules */}
      <Dialog
        open={payoutDialog.open}
        onClose={closePayouts}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontWeight: 700,
            color: "#b71c1c",
            position: "sticky",
            top: 0,
            zIndex: 1,
            bgcolor: "background.paper",
            borderBottom: "1px solid rgba(0,0,0,0.06)",
          }}
        >
          <InfoOutlinedIcon fontSize="small" /> Payouts & Rules
          <IconButton
            onClick={closePayouts}
            sx={{ ml: "auto" }}
            aria-label="close payouts dialog"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {payoutDialog.item ? (
            <>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 700 }}>
                Pool Breakdown
              </Typography>
              {getPayoutTable(payoutDialog.item.leatherboard)}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1.5}
                sx={{ mt: 2 }}
              >
                <Stat
                  label="Sport"
                  value={payoutDialog.item.sportName}
                  tone="info"
                />
                <Stat
                  label="Team Size"
                  value={payoutDialog.item.teamSize}
                  tone="default"
                />
                <Stat
                  label="Max/User"
                  value={payoutDialog.item.entryPerPlayer}
                  tone="success"
                />
                <Stat
                  label="Remaining"
                  value={payoutDialog.item.freeEntries}
                  tone="warning"
                />
              </Stack>
              <FantasyScoringTable sportName={payoutDialog.item.sportName} />
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={closePayouts}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const Stat = ({ label, value, icon: Icon, tone = "default" }) => {
  const toneColor =
    {
      success: "#2e7d32",
      info: "#0277bd",
      warning: "#ed6c02",
      default: "rgba(0,0,0,0.12)",
    }[tone] || "rgba(0,0,0,0.12)";

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        textAlign: "center",
        borderRadius: 2,
        position: "relative",
        overflow: "hidden",
        borderColor: "rgba(0,0,0,0.08)",
        bgcolor: "#fff",
        transition: "box-shadow .2s ease, transform .2s ease",
        "&:hover": { boxShadow: 3, transform: "translateY(-1px)" },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          bgcolor: toneColor,
        }}
      />
      <Stack alignItems="center" spacing={0.5}>
        <Stack direction="row" spacing={0.5} alignItems="center">
          {Icon ? <Icon fontSize="small" /> : null}
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ letterSpacing: 0.3 }}
          >
            {label}
          </Typography>
        </Stack>
        <Typography
          variant="body1"
          sx={{ fontWeight: 800, fontVariantNumeric: "tabular-nums" }}
        >
          {value ?? "—"}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default Poolcard;
